<template>
    <div class="relative">
        <div class="web-dev-click blue-palce text-center">
            <div class="filters-abetca">
                <span v-for="letter in letters" :class="filters.letter == letter ? 'active' : ''"
                      @click="changeLetter(letter)">{{letter}}</span>
            </div>
        </div>
        <div class="full-image" v-if="BigImagekey !== false">
            <div class="bg" @click="closeFullImage()">x</div>
            <div class="window">
                <span @click="changeImage('minus')" class="prev-flower">-</span>
                <div class="image">
                    <div class="image-block" @click="openFullImage(key)">
<!--                        <div class="cross" @click="closeFullImage()">x</div>-->
                        <div class="my-close-btn" @click="closeFullImage()"></div>
                        <div class="original_open">
                            <img
                                    :src="data[BigImagekey].origin"
                                    :alt="data[BigImagekey].name">
<!--                            <img-->
<!--                                :src="data[BigImagekey].origin_prev"-->
<!--                                :alt="data[BigImagekey].name">-->
                        </div>
                    </div>
                    <p class="name">{{data[BigImagekey].name}}</p>
                </div>
                <span @click="changeImage('plus')" class="next-flower">+</span>
            </div>
        </div>
        <div class="container p-0">

            <ul class="block-flowers flower-page row row-gap" :class="loading ? 'loading' : ''">
                <li v-for="(flower, key) in data" class="col-6 col-md-3 col-lg-2">
                    <div class="gallery-item">
                        <div class="image h-100" @click="openFullImage(key)"><img
                                :src="flower.thumbs"
                                :alt="flower.name"
                                :title="flower.name"></div>
                        <p class="block-name">{{flower.name}}</p>
                    </div>

                </li>
            </ul>

        </div>
    </div>
</template>

<script>
    var urlParams = new URLSearchParams(window.location.search);
    export default {
        name: "catalog-flower-page",
        components: {},
        data() {
            return {
                loading: false,
                data: {},
                category: {},
                BigImagekey: false,
                letters: {},
                filters: {
                    category: '',
                    letter: '',
                },
            }
        },
        props: {
            categoryId: {
                required: false
            }
        },
        methods: {
            updateData() {
                this.loading = true;
                axios.post('/flowers/get-data', this.filters).then(res => {
                    this.letters = res.data.letters;
                    this.filters.letter = this.filters.letter ? this.filters.letter : this.letters[0];
                    this.data = res.data.data;
                    this.loading = false;
                }).catch(err => this.loading = false);

            },
            changeLetter(letter) {
                this.filters.letter = letter;
                this.BigImagekey = false;
                this.updateData();
            },
            openFullImage(key) {
                this.BigImagekey = key
            },
            closeFullImage() {
                this.BigImagekey = false;
            },
            changeImage(type) {

                if (type == 'plus') {
                    console.log(type);
                    if ((this.BigImagekey + 1) > (this.data.length - 1)) {
                        this.BigImagekey = 0;
                        console.log('1');
                    } else {
                        this.BigImagekey = ++this.BigImagekey;
                        console.log('2');
                    }
                }
                if (type == 'minus') {

                    if (this.BigImagekey == 0) {
                        this.BigImagekey = this.data.length - 1
                    } else {
                        this.BigImagekey = --this.BigImagekey;
                    }
                }
            }
        },
        computed: {},
        watch: {
            filters: {
                handler: _.debounce(
                    function () {
                        this.updateData();
                    }, 500
                ),
                deep: true
            },
        },
        mounted() {
            this.filters.category = this.categoryId;
            this.updateData();
            
        }
    }
</script>



// WEBPACK FOOTER //
// resources/js/components/elements/CatalogFlowePage.vue